<app-page-header [header]="'contactUs.header'" />

<div class="bg-blue mt-5 p-3 p-md-5">
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-4 position-relative pb-5">
        <div class="form bg-light rounded-4">
          <h5 class="bg-l text-black text-center py-3 px-5 rounded-top-4">
            {{ "contactUs.leaveYourMessage" | translate }}
          </h5>
          <form #messageForm="ngForm" (ngSubmit)="messageForm.valid && sendMessage()" autocomplete="off"
            class="max-width-">
            <div class="px-3 pb-3">
              <app-input [currentForm]="messageForm" class="" [(ngModel)]="message.name" name="'name'"
                [inputDivCssClass]="'col-12 p-0 py-3'" [inputCssClass]="'rounded-2'" [required]="true" ngDefaultControl
                inputContainerClass="col-12 p-0 " [inputPlaceholder]="'contactUs.name' | translate" />
              <app-input class="" [(ngModel)]="message.email" name="'email'" [inputDivCssClass]="'col-12 p-0 py-1'"
                [inputCssClass]="'rounded-2'" [required]="true" ngDefaultControl inputContainerClass="col-12 p-0 "
                [inputPlaceholder]="'contactUs.email' | translate" [currentForm]="messageForm"
                [pattern]="'[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}'"
                [errorPatternMessage]="'contactUs.emailRequired'" />

              <div class="col-12 py-3">
                <form #f="ngForm" [formGroup]="mobileForm">
                  <ngx-intl-tel-input [cssClass]="'form-control w-100 phone-input mb-2'" [preferredCountries]="[
                      countryISO.UnitedStates,
                      countryISO.UnitedKingdom
                    ]" [enableAutoCountrySelect]="false" [enablePlaceholder]="true" [searchCountryFlag]="true"
                    [searchCountryField]="[
                      searchCountryField.Iso2,
                      searchCountryField.Name
                    ]" [selectFirstCountry]="false" [selectedCountryISO]="countryISO.Egypt" [maxLength]="15"
                    [phoneValidation]="true" [inputId]="'mobileFormControl'" name="mobileFormControl"
                    formControlName="mobileFormControl" [(ngModel)]="mobile" required="true" [cssClass]="
                      mobileForm.controls['mobileFormControl']!.errors &&
                      (phoneFormGroupControl['mobileFormControl'].touched ||
                        messageForm.submitted)
                        ? 'form-control border-danger'
                        : 'form-control'
                    "></ngx-intl-tel-input>

                  @if((mobileForm.controls['mobileFormControl'].touched ||
                  messageForm.submitted) &&
                  phoneFormGroupControl['mobileFormControl'].errors?.['validatePhoneNumber']){
                  <p class="p-0 m-0 text-danger">
                    {{ "inputComponent.validatePhoneNumber" | translate }}
                  </p>
                  } @if((mobileForm.controls['mobileFormControl'].touched ||
                  messageForm.submitted) &&
                  phoneFormGroupControl['mobileFormControl'].errors?.['required']){
                  <p class="p-0 m-0 text-danger">
                    {{ "inputComponent.required" | translate }}
                  </p>
                  }
                </form>
              </div>

              <textarea autocapitalize="none" [placeholder]="'contactUs.message' | translate" name="message"
                class="form-control py-3 rounded-2 pt-3" [(ngModel)]="message.message" rows="3" required="true"
                #messageTextarea="ngModel" [ngClass]="{
                  'border-danger':
                    (messageTextarea.touched || messageForm?.submitted) &&
                    messageTextarea?.errors?.['required']
                }"></textarea>
              <p class="p-0 m-0 text-danger p-0 m-0"
                *ngIf="(messageTextarea.touched || messageForm?.submitted)&& messageTextarea?.errors?.['required']">
                {{ "contactUs.required" | translate }}
              </p>
              <div class="py-3">
                <button class="btn btn-primary w-100" [disabled]="messageForm.invalid || mobileForm.invalid">
                  {{ "contactUs.submit" | translate }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="col-12 col-md-8 px-5 info">
        <div class="row">
          <div class="col-12 col-md-6" *ngFor="let link of contactUsLinks">
            <div class="p-circle">
              <h5>{{ link.name | translate }}</h5>
              <p [innerHTML]="isArabic ? link.descriptionAr : link.descriptionEn"
                [dir]="isArabic && (link.name === 'footer.phone' || link.name === 'footer.fax') ? 'ltr' : ''" [ngClass]="{
                  'text-start':
                    isArabic &&
                    (link.name === 'footer.phone' || link.name === 'footer.fax')
                }"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>